import src from "IMAGE";
export default { src, width: 1305, height: 1151, blurWidth: 0, blurHeight: 0};
